import { getInlineFileSizeText } from './get-inline-file-size-text';
import { getInlinePdfPageCount } from './get-inline-pdf-page-count';

export const getFileInlineMetadata = async (file: File) => {
  let inlineMetaData = '';
  if (file.type.endsWith('pdf')) {
    inlineMetaData = `${await getInlinePdfPageCount(file)} pages`;
  } else if (file.type.startsWith('video')) {
    inlineMetaData = getInlineFileSizeText(file).toLocaleUpperCase();
  }

  return inlineMetaData;
};
